import { MDXProvider } from "@mdx-js/react";
import { ReactNode } from "react";
import {
  Callout,
  Steps,
  Step,
  CardGrid,
  Card,
  ProductBadge,
  CodeBlock,
  RelatedLinks,
  RelatedLink,
} from "./docs";

// These are available in every .mdx file with no import needed.
// To add a new global component, export it from docs/index.ts and add it here.
const components = {
  // Custom doc components
  Callout,
  Steps,
  Step,
  CardGrid,
  Card,
  ProductBadge,
  CodeBlock,
  RelatedLinks,
  RelatedLink,
  // Override default HTML elements rendered from markdown
  pre: ({ children }: { children: ReactNode }) => <>{children}</>,
  code: ({ children, className }: { children: ReactNode; className?: string }) => {
    const language = className?.replace("language-", "");
    // Block code (inside pre) vs inline code is handled differently in MDX
    // If it has a language class it's a fenced block
    if (language) {
      return <CodeBlock language={language}>{children}</CodeBlock>;
    }
    return (
      <code className="bg-bg-secondary text-text border border-border text-xs font-mono px-1.5 py-0.5 rounded">
        {children}
      </code>
    );
  },
};

export function DocsProvider({ children }: { children: ReactNode }) {
  return <MDXProvider components={components}>{children}</MDXProvider>;
}
